import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';

class Redirect extends Component {

    componentDidUpdate = () => {
        this.props.history.push('/projects');
    }

    render() {
        return (
            <div>
                <h1>Redirecting</h1>
            </div>
        );
    }
}

Redirect.propTypes = {
    history: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return { 
        data: state
    }
}

const connect_redirect = connect(
    mapStateToProps
  )(Redirect);

export default withRouter(connect_redirect);